import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import DashboardHeader from "./partial/dashboard-header";
import DashboardMenu from "./partial/dashboard-menu";
import DashboardFooter from "./partial/dashboard-footer";
import DashboardWrapper from "./partial/dashboard-wrapper";
import DashboardContent from "./partial/dashboard-content";
import CssBaseline from "@material-ui/core/CssBaseline";
import { isMobileOnly } from "react-device-detect";
import { useAuthDataContext } from "components/auth";
import { getAvailableLocales } from "components/i18n-provider";
import { useCustomThemeContext } from "components/mui-providers";

const Dashboard = ({ className, children }) => {
  const { locale, onLocaleChange } = useAuthDataContext();
  const { customTheme } = useCustomThemeContext();

  const [open, setOpen] = useState(!isMobileOnly);
  const [availableLocales, setAvailableLocales] = useState([]);

  const handleDrawerOpen = useCallback(() => setOpen(true), []);
  const handleDrawerClose = useCallback(() => setOpen(false), []);

  useEffect(() => {
    getAvailableLocales().then(setAvailableLocales);
  }, []);

  return (
    <DashboardWrapper className={className}>
      <CssBaseline />
      <DashboardHeader
        open={open}
        onDrawerOpen={handleDrawerOpen}
        availableLocales={availableLocales}
        locale={locale}
        onLocaleChange={onLocaleChange}
        url={customTheme.headerData.logo.link}
        logoUrl={customTheme.headerData.logo.src}
        logoAlt={customTheme.headerData.logo.alt}
      />

      <DashboardMenu open={open} onDrawerClose={handleDrawerClose} />

      <DashboardContent>{children}</DashboardContent>

      <DashboardFooter
        open={open}
        url={customTheme.footerData.logo.link}
        logoUrl={customTheme.footerData.logo.src}
        logoAlt={customTheme.footerData.logo.alt}
      />
    </DashboardWrapper>
  );
};

Dashboard.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
};

export default injectIntl(Dashboard);
